import React from 'react';
import { MapPin, Phone, Instagram, Heart } from 'lucide-react';
import { siteData } from '../data/siteData';

const Footer = () => {
  const navLinks = [
    { href: '#inicio', label: 'Inicio' },
    { href: '#nosotros', label: 'Nosotros' },
    { href: '#servicios', label: 'Servicios' },
    { href: '#opiniones', label: 'Opiniones' },
    { href: '#contacto', label: 'Contacto' },
  ];

  const handleNavClick = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[var(--color-dark)] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="py-12 sm:py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
            {/* Brand Column */}
            <div className="lg:col-span-2">
              <img
                src={siteData.business.logo}
                alt={siteData.business.name}
                className="h-16 w-auto rounded-lg mb-4"
              />
              <p className="text-gray-400 max-w-md mb-6">
                {siteData.business.description}
              </p>
              <a
                href={siteData.social.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-gray-400 hover:text-[var(--color-magenta)] transition-colors"
              >
                <Instagram className="w-5 h-5" />
                {siteData.social.instagramHandle}
              </a>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-lg font-semibold mb-4">Navegación</h4>
              <nav className="flex flex-col space-y-2">
                {navLinks.map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    onClick={(e) => handleNavClick(e, link.href)}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    {link.label}
                  </a>
                ))}
              </nav>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="text-lg font-semibold mb-4">Contacto</h4>
              <div className="space-y-4">
                {siteData.locations.map((location) => (
                  <div key={location.id} className="flex items-start gap-3">
                    <MapPin className="w-5 h-5 text-[var(--color-magenta)] flex-shrink-0 mt-0.5" />
                    <div>
                      <p className="text-sm font-medium">{location.city}</p>
                      <a
                        href={`tel:${location.phone.replace(/\s/g, '')}`}
                        className="text-sm text-gray-400 hover:text-white transition-colors flex items-center gap-1"
                      >
                        <Phone className="w-3 h-3" />
                        {location.phone}
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 py-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-gray-400 text-center sm:text-left">
              © {siteData.footer.year} {siteData.business.name}
            </p>
            <p className="text-sm text-gray-400 flex items-center gap-1">
              Desarrollado con <Heart className="w-4 h-4 text-[var(--color-magenta)] fill-[var(--color-magenta)]" /> por{' '}
              <a
                href={siteData.footer.developer.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-[var(--color-cyan)] transition-colors font-medium"
              >
                {siteData.footer.developer.name}
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
